
/**
 * EmailDestinatario
 * @author ftgibran
 */
import {$, HttpBody, ID, Resource, ResponseHidden, ResponseSerialize} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'

export default class EmailDestinatario extends Resource {
  static async listEmailDestinatario(spinner = 'listEmailDestinatario') {
    const fetch = async () => {
      // @ts-ignore
      return await new HttpBody<EmailDestinatario[]>(EmailDestinatario).GET('/user/email-destinatario')
    }

    return await $.await.run(fetch, spinner)
  }

  static async listCpfCnpjDestinatario(spinner = 'listCpfCnpjDestinatario') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET('/user/email-destinatario/cpfCnpj')
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'EmailDestinatario'

  readonly $endpoint: string = '/user/email-destinatario{/id}'

  get $id() {
    return this.cpfCnpj || ''
  }

  get $tag() {
    return this.cpfCnpj ? Helper.cpfOrCnpj(this.cpfCnpj) : ''
  }

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  email: string | null = null
  cpfCnpj: string | null = null

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  async listEmailsByCpfCnpj(spinner = 'listEmailsByCpfCnpj') {
    const fetch = async () => {
      return await new HttpBody<string[]>(Array).GET(`/user/email-destinatario/${this.cpfCnpj}`)
    }

    return await $.await.run(fetch, spinner)
  }
}
